import React from 'react';
import classnames from 'classnames';

export interface ListGroupProps extends React.HTMLProps<HTMLElement> {
  className?: string;
  tag?: string;
}

const ListGroup: React.FunctionComponent<ListGroupProps> = ({
  tag: Tag = 'div',
  className = '',
  children,
  ...otherProps
}) => {
  return (
    // https://github.com/Microsoft/TypeScript/issues/28892
    // @ts-ignore
    <Tag className={classnames('mdc-list-group', className)} {...otherProps}>
      {children}
    </Tag>
  );
};

export default ListGroup;
